/* ============================================================
   MS — interacciones propias. Vanilla, sin librerias.
   ============================================================ */
(function () {
  'use strict';

  // el archivo se incluye desde cada seccion: ejecutar una sola vez
  if (window.__msListo) return;
  window.__msListo = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveals al hacer scroll (un solo observer) ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.ms-reveal, .ms-clip, .ms-hero');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ms-visible'); });
      return;
    }
    var disparo = false;
    var obs = new IntersectionObserver(function (entries) {
      disparo = true;
      entries.forEach(function (e) {
        // isIntersecting cubre el caso normal; boundingClientRect.top < 0 rescata
        // los elementos que quedaron por encima al bajar de golpe o al abrir un ancla
        if (e.isIntersecting || e.boundingClientRect.top < 0) {
          e.target.classList.add('ms-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });

    function mostrarLoVisible() {
      document.querySelectorAll('.ms-reveal:not(.ms-visible), .ms-clip:not(.ms-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('ms-visible');
      });
    }

    // red de seguridad: si el observador no llega a dispararse, el contenido no
    // puede quedarse invisible para siempre. Pasamos a revelar con el scroll.
    setTimeout(function () {
      mostrarLoVisible();
      if (!disparo) {
        obs.disconnect();
        window.addEventListener('scroll', mostrarLoVisible, { passive: true });
        window.addEventListener('resize', mostrarLoVisible, { passive: true });
      }
    }, 3000);
  }

  /* ---------- cifras que cuentan ---------- */
  function initContadores() {
    var els = document.querySelectorAll('[data-ms-contador]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = el.getAttribute('data-ms-contador'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.unobserve(e.target);
        contar(e.target);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { obs.observe(el); });

    function contar(el) {
      var destino = parseFloat(el.getAttribute('data-ms-contador'));
      if (isNaN(destino)) { el.textContent = el.getAttribute('data-ms-contador'); return; }
      var decimales = (String(destino).split('.')[1] || '').length;
      var dur = 1500, ini = null;
      function paso(t) {
        if (!ini) ini = t;
        var p = Math.min((t - ini) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (destino * eased).toFixed(decimales);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
  }

  /* ---------- parallax suave del hero ---------- */
  function initParallax() {
    var els = document.querySelectorAll('[data-ms-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function pintar() {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var fuerza = parseFloat(el.getAttribute('data-ms-parallax')) || 0;
        var avance = (window.innerHeight - r.top) / (window.innerHeight + r.height);
        var y = (avance - 0.5) * fuerza;
        el.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(pintar); }
    }, { passive: true });
    pintar();
  }

  /* ---------- despiece: puntos <-> lista ---------- */
  function initDespiece() {
    document.querySelectorAll('[data-ms-despiece]').forEach(function (raiz) {
      var puntos = raiz.querySelectorAll('.ms-desp__punto');
      var items = raiz.querySelectorAll('.ms-desp__item');
      if (!items.length) return;

      function activar(i) {
        puntos.forEach(function (p, n) { p.classList.toggle('is-on', n === i); });
        items.forEach(function (it, n) { it.classList.toggle('is-on', n === i); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { activar(i); });
        p.addEventListener('focus', function () { activar(i); });
        p.addEventListener('click', function () {
          activar(i);
          if (items[i]) items[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
      });
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { activar(i); });
        it.addEventListener('focus', function () { activar(i); });
        it.addEventListener('click', function () { activar(i); });
      });
      activar(0);
    });
  }

  /* ---------- FAQ acordeon (altura animada de verdad) ---------- */
  function initFaq() {
    document.querySelectorAll('.ms-faq__item').forEach(function (item) {
      var q = item.querySelector('.ms-faq__q');
      var a = item.querySelector('.ms-faq__a');
      if (!q || !a) return;
      q.setAttribute('aria-expanded', 'false');
      q.addEventListener('click', function () {
        var abierto = item.classList.contains('is-on');
        var hermanos = item.parentElement.querySelectorAll('.ms-faq__item.is-on');
        hermanos.forEach(function (h) {
          if (h === item) return;
          h.classList.remove('is-on');
          var ha = h.querySelector('.ms-faq__a');
          var hq = h.querySelector('.ms-faq__q');
          if (ha) ha.style.height = '0px';
          if (hq) hq.setAttribute('aria-expanded', 'false');
        });
        if (abierto) {
          a.style.height = '0px';
          item.classList.remove('is-on');
          q.setAttribute('aria-expanded', 'false');
        } else {
          a.style.height = a.scrollHeight + 'px';
          item.classList.add('is-on');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
    window.addEventListener('resize', function () {
      document.querySelectorAll('.ms-faq__item.is-on .ms-faq__a').forEach(function (a) {
        a.style.height = a.scrollHeight + 'px';
      });
    });
  }

  /* ---------- galeria de producto ---------- */
  function initGaleria() {
    document.querySelectorAll('[data-ms-galeria]').forEach(function (raiz) {
      var grande = raiz.querySelector('.ms-prod__principal img');
      var marco = raiz.querySelector('.ms-prod__principal');
      var minis = raiz.querySelectorAll('.ms-prod__mini');
      if (!grande || !minis.length) return;
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          var src = m.getAttribute('data-src');
          var srcset = m.getAttribute('data-srcset');
          var alt = m.getAttribute('data-alt') || '';
          if (!src || grande.getAttribute('src') === src) return;
          marco.classList.add('is-cargando');
          var pre = new Image();
          pre.onload = function () {
            // la foto grande tiene srcset: si solo se cambia src, el navegador
            // sigue mostrando la del srcset y la foto no cambia. Hay que
            // reemplazar (o quitar) el srcset junto con el src.
            if (srcset) grande.setAttribute('srcset', srcset);
            else grande.removeAttribute('srcset');
            grande.src = src;
            grande.alt = alt;
            marco.classList.remove('is-cargando');
          };
          pre.onerror = function () { marco.classList.remove('is-cargando'); };
          pre.src = src;
          minis.forEach(function (o) { o.classList.remove('is-on'); });
          m.classList.add('is-on');
        });
      });
    });
  }

  /* ---------- selector de variantes ---------- */
  function initVariantes() {
    document.querySelectorAll('[data-ms-variantes]').forEach(function (raiz) {
      var datos = raiz.querySelector('script[data-ms-variantes-json]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var input = raiz.querySelector('input[name="id"]');
      var boton = raiz.querySelector('.ms-prod__add');
      var precio = raiz.querySelector('[data-ms-precio]');
      var antes = raiz.querySelector('[data-ms-antes]');
      var stock = raiz.querySelector('[data-ms-stock]');
      var textoStock = raiz.getAttribute('data-texto-stock') || 'En stock';
      var textoAgotado = raiz.getAttribute('data-texto-agotado') || 'Agotado';
      var textoBoton = raiz.getAttribute('data-texto-boton') || 'Agregar al carrito';

      var grupos = raiz.querySelectorAll('.ms-prod__opcion');
      if (!grupos.length) return;

      function elegidas() {
        return Array.prototype.map.call(grupos, function (g) {
          var lista = g.querySelector('.ms-prod__lista');
          if (lista) return lista.value;
          var on = g.querySelector('.ms-prod__valor.is-on');
          return on ? on.getAttribute('data-valor') : null;
        });
      }

      function actualizar() {
        var sel = elegidas();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) return;
        if (input) input.value = v.id;
        if (precio) precio.innerHTML = v.price;
        if (antes) {
          antes.innerHTML = v.compare_at_price || '';
          antes.style.display = v.compare_at_price ? '' : 'none';
        }
        if (stock) {
          stock.classList.toggle('is-off', !v.available);
          var t = stock.querySelector('span');
          if (t) t.textContent = v.available ? textoStock : textoAgotado;
        }
        if (boton) {
          boton.disabled = !v.available;
          var bt = boton.querySelector('.ms-btn__t');
          if (bt) bt.textContent = v.available ? textoBoton : textoAgotado;
        }
      }

      grupos.forEach(function (g) {
        g.querySelectorAll('.ms-prod__valor').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('.ms-prod__valor').forEach(function (o) { o.classList.remove('is-on'); });
            b.classList.add('is-on');
            actualizar();
          });
        });
        var lista = g.querySelector('.ms-prod__lista');
        if (lista) lista.addEventListener('change', actualizar);
      });

      actualizar();
    });
  }

  function arrancar() {
    initReveals();
    initContadores();
    initParallax();
    initDespiece();
    initFaq();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // el editor de Shopify recarga secciones sueltas: re-inicializar
  document.addEventListener('shopify:section:load', arrancar);
})();
